export default function updateFormAction(state: any, payload?: any) {
  return {
    ...state,
    ...payload,
  };
}
